export default {
    state: {
        all: [],
        filtered: [],
        scenarios: {},
        selectedScenarioId: null
    },
    getters: {
        scenario: (state) => {
            if (state.selectedScenarioId != null) {
                return _.find(state.scenarios, ['id', state.selectedScenarioId])
            }

            return null;
        },

        scenarioKsds: (state, getters) => {
            if (getters.scenario) {
                return getters.scenario.ksds;
            }

            return {};
        }
    }
};